import { Pipe, PipeTransform } from '@angular/core';
import { FilterItemModel } from '../../../core/models/misc/filter-item.model';

@Pipe({
    name: 'filterByFilterItems',
    standalone: false
})
export class FilterByFilterItemsPipe implements PipeTransform {
    transform(data: any[], filterItems?: FilterItemModel[]): any[] {
        if (!data || !filterItems || filterItems.length === 0) {
            return data;
        }

        return data.map(item => {
            const clonedItem = {...item};
            if (item.children) {
                clonedItem.children = [...item.children];
            }

            const passesAllFilters = filterItems.every(filterItem => {
                const splitProperties: string[] = filterItem.filterProperty.split('.');

                let parentValue = clonedItem;
                splitProperties.forEach(prop => {
                    parentValue = parentValue?.[prop];
                });

                const parentMatches = parentValue && filterItem.filterValues.includes(parentValue);

                let childrenMatch = false;
                if (clonedItem.children) {
                    clonedItem.children = clonedItem.children.filter((childItem: any) => {
                        let childValue = childItem;
                        splitProperties.forEach(prop => {
                            childValue = childValue?.[prop];
                        });

                        const matches = childValue && filterItem.filterValues.includes(childValue);
                        if (matches) {
                            childrenMatch = true;
                        }
                        return matches;
                    });
                }

                return parentMatches || childrenMatch;
            });

            return passesAllFilters ? clonedItem : null;
        }).filter(Boolean);
    }
}